import { useNavigate } from "react-router-dom";
import { useLiveQuery } from "dexie-react-hooks";
import { getConfig, getCriancaAtiva, salvarConfig } from "../../db/queries";
import { idade } from "../../lib/format";

/**
 * Configurações do Compasso. Paciente/responsável e backup são compartilhados entre
 * os módulos do Degrau; aqui só os ajustes do módulo musical.
 */
export function ConfigMusica() {
  const nav = useNavigate();
  const cfg = useLiveQuery(getConfig);
  const crianca = useLiveQuery(getCriancaAtiva);
  const anos = idade(crianca?.data_nascimento ?? null);

  return (
    <main className="tela">
      <button className="btn btn-fantasma" onClick={() => nav(-1)}>
        ← voltar
      </button>
      <h1 className="tela-titulo">configurações · Compasso</h1>

      <section className="secao">
        <h2 className="secao-titulo">paciente</h2>
        <button
          className="card linha-alimento"
          onClick={() => nav("/paciente")}
          style={{ width: "100%" }}
        >
          <div className="foto" aria-hidden>
            👤
          </div>
          <div className="crescer">
            {crianca ? (
              <>
                <div className="nome">
                  {crianca.nome_completo || crianca.apelido}
                  {anos !== null && (
                    <span className="meta"> · {anos} {anos === 1 ? "ano" : "anos"}</span>
                  )}
                </div>
                <div className="meta">o cadastro é compartilhado entre os módulos</div>
              </>
            ) : (
              <>
                <div className="nome">completar cadastro</div>
                <div className="meta">paciente e responsável</div>
              </>
            )}
          </div>
          <span aria-hidden>→</span>
        </button>
      </section>

      <section className="secao">
        <h2 className="secao-titulo">lembrete de rotina</h2>
        <div className="card">
          <div className="campo" style={{ margin: 0 }}>
            <label>retomar uma experiência em exploração a cada (dias)</label>
            <input
              type="number"
              min={1}
              max={30}
              value={cfg?.musica_rotina_dias ?? 5}
              onChange={(e) => salvarConfig({ musica_rotina_dias: Number(e.target.value) })}
            />
          </div>
        </div>
      </section>

      <section className="secao">
        <h2 className="secao-titulo">modo escolha da criança</h2>
        <div className="card">
          <div className="campo" style={{ margin: 0 }}>
            <label>quantas opções aparecem (2 ou 3)</label>
            <input
              type="number"
              min={2}
              max={3}
              value={cfg?.musica_escolha_qtd ?? 2}
              onChange={(e) =>
                salvarConfig({
                  musica_escolha_qtd: Math.max(2, Math.min(3, Number(e.target.value))),
                })
              }
            />
          </div>
        </div>
      </section>

      <section className="secao">
        <h2 className="secao-titulo">privacidade & segurança sensorial</h2>
        <p style={{ color: "var(--text-muted)", fontSize: "0.9rem" }}>
          tudo fica neste aparelho, sem conta. fotos e clipes de áudio (inclusive a voz
          da criança) só saem quando você exporta. nenhum som toca sozinho: a reprodução
          só acontece por toque.
        </p>
      </section>
    </main>
  );
}
